package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.String

public class AppPreferenceQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun getValue(key: String): Query<String> = GetValueQuery(key) { cursor ->
    cursor.getString(0)!!
  }

  public fun <T : Any> selectAll(mapper: (key: String, pref_value: String) -> T): Query<T> =
      Query(1_950_279_015, arrayOf("app_preference"), driver, "AppPreference.sq", "selectAll",
      "SELECT app_preference.key, app_preference.pref_value FROM app_preference") { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!
    )
  }

  public fun selectAll(): Query<App_preference> = selectAll { key, pref_value ->
    App_preference(
      key,
      pref_value
    )
  }

  public fun setValue(key: String, pref_value: String) {
    driver.execute(-1_661_635_699,
        """INSERT OR REPLACE INTO app_preference(key, pref_value) VALUES (?, ?)""", 2) {
          bindString(0, key)
          bindString(1, pref_value)
        }
    notifyQueries(-1_661_635_699) { emit ->
      emit("app_preference")
    }
  }

  public fun deleteValue(key: String) {
    driver.execute(294_185_064, """DELETE FROM app_preference WHERE key = ?""", 1) {
          bindString(0, key)
        }
    notifyQueries(294_185_064) { emit ->
      emit("app_preference")
    }
  }

  private inner class GetValueQuery<out T : Any>(
    public val key: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("app_preference", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("app_preference", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_100_523_239,
        """SELECT pref_value FROM app_preference WHERE key = ?""", mapper, 1) {
      bindString(0, key)
    }

    override fun toString(): String = "AppPreference.sq:getValue"
  }
}
